import { For, onMount } from 'solid-js'
import {
  CELEBRATION_DURATION_MS,
  CELEBRATION_PARTICLES,
  particleAnimations,
  type CelebrationParticle,
} from '~/lib/unlock-celebration'

function Particle(props: { particle: CelebrationParticle }) {
  let element: HTMLDivElement | undefined
  onMount(() => {
    // Environments without WAAPI (happy-dom tests, ancient WebViews) keep the
    // particle at its invisible base until the shell's timer removes it.
    if (typeof element?.animate !== 'function') return
    for (const keyframes of particleAnimations(props.particle)) {
      element.animate(keyframes, { duration: CELEBRATION_DURATION_MS })
    }
  })
  return (
    <div
      ref={(node) => {
        element = node
      }}
      class="absolute opacity-0"
      style={{
        height: `${props.particle.box.height}px`,
        left: `${props.particle.box.left}px`,
        top: `${props.particle.box.top}px`,
        width: `${props.particle.box.width}px`,
      }}
    >
      {props.particle.artInset ? (
        <div class="absolute" style={{ inset: props.particle.artInset }}>
          <img alt="" src={props.particle.asset} class="size-full" />
        </div>
      ) : (
        <img
          alt=""
          src={props.particle.asset}
          class="absolute inset-0 size-full"
        />
      )}
    </div>
  )
}

/**
 * The unlock celebration (GLOSSARY.md): one confetti cycle over a Classic
 * card's tree art. Purely visual — the shell owns when it mounts and when
 * the cycle is over. The stage is authored in the Figma component's 120×96
 * space and scaled about its centre to its mounted 206×164.8 footprint so
 * the keyframe data applies verbatim; centring it on the slot keeps it
 * aligned whatever width the card takes.
 */
export function UnlockCelebration() {
  return (
    <div
      aria-hidden="true"
      data-testid="unlock-celebration"
      class="pointer-events-none absolute left-1/2 top-0 z-10 h-24 w-[120px] -translate-x-1/2 scale-[1.71667]"
    >
      <For each={CELEBRATION_PARTICLES}>
        {(particle) => <Particle particle={particle} />}
      </For>
    </div>
  )
}
